<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="pii"></a><a class="page" id="piii"></a>Start-Up Poland</h1>
<h1 class="bk1">THE PEOPLE WHO TRANSFORMED AN ECONOMY</h1>
<p class="bkau">Jan Cienski</p>
<p class="bkpub">THE UNIVERSITY OF CHICAGO PRESS</p>
<p class="bkpub1">Chicago and London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-cienski-0003.vue?37a379c7